// src/store/slices/taggingSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FormState {
  isLabelRubberbandEnabled: boolean | null;
  labelRubberbandMetrics: any | null; // Store the metrics
  currentFieldLabel: string | null;
  isAddPatternRubberBandEnabled: boolean ;
}

const initialState: FormState = {
  isLabelRubberbandEnabled: false,
  labelRubberbandMetrics: null,
  currentFieldLabel: null,
  isAddPatternRubberBandEnabled: false
};

const taggingSlice = createSlice({
  name: 'tagging',
  initialState,
  reducers: {
    setLabelRubberbandEnabled: (state) => {
      state.isLabelRubberbandEnabled = true;
    },
    setLabelRubberbandDisabled: (state) => {
      state.isLabelRubberbandEnabled = false;
    },
    setLabelRubberbandMetrics: (state, action: PayloadAction<any>) => {
      state.labelRubberbandMetrics = action.payload;
    },
    clearLabelRubberbandMetrics: (state) => {
      state.labelRubberbandMetrics = null;
    },
    setCurrentFieldLabel: (state, action: PayloadAction<string>) => {
      state.currentFieldLabel = action.payload;
    },
    clearCurrentFieldLabel: (state) => {
      state.currentFieldLabel = null;
    },
    // To clear the green rubber band
    removeLabelRubberBand: (state) => {
      state.isLabelRubberbandEnabled = null;
    },
    setAddPatternRubberBand: (state, action: PayloadAction<boolean>) => {
      state.isAddPatternRubberBandEnabled = action.payload;
    }
  }
});

export const {
  setLabelRubberbandEnabled,
  setLabelRubberbandDisabled,
  setLabelRubberbandMetrics,
  clearLabelRubberbandMetrics,
  setCurrentFieldLabel,
  clearCurrentFieldLabel,
  removeLabelRubberBand,
  setAddPatternRubberBand
} = taggingSlice.actions;

export default taggingSlice.reducer;
